import { createSlice } from "@reduxjs/toolkit";


const staffMemberSlice = createSlice({
    name: "staffMemberSetting",
    initialState: {
        staffMembersData: [],
        totalItems: [],
        itemsPerPage: 10
    },
    reducers: {
        setStaffMembersData: (state, action) => {
            state.staffMembersData = action.payload;
        },

        setTotalItems: (state, action) => {
            state.totalItems = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;
        }


    }
});

export const {
    setStaffMembersData,
    setTotalItems,
    setItemsPerPage
} = staffMemberSlice.actions;

export default staffMemberSlice.reducer;